var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 102,
    viewBox: "0 0 140 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2080_2396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.25781 22.0078H-0.322875",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3038 55.4232C77.9407 56.0294 77.8436 56.728 78.0302 57.391C78.3346 58.0456 78.8015 58.6351 79.3982 59.1179L79.8561 61.5571L86.0655 61.7929L83.508 53.5938L78.3038 55.4232Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0938 40.2114C74.0938 40.2114 76.681 54.7136 77.0676 55.5847C77.4542 56.4559 80.4339 57.4808 81.4748 57.035C82.5156 56.5891 80.6956 54.4727 80.6956 54.4727L81.2131 40.5291C81.2131 40.5291 76.8118 39.084 74.0938 40.2114Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3339 44.7694C81.3339 44.7694 77.7059 44.5491 77.575 45.1076C77.4442 45.6662 77.4501 47.5571 78.0984 47.7826C78.7467 48.0081 83.148 48.3412 83.9211 48.1157C84.18 48.0025 84.4098 47.8454 84.5966 47.6539C84.7834 47.4624 84.9235 47.2405 85.0084 47.0013C85.0934 46.7621 85.1214 46.5106 85.091 46.2618C85.0605 46.013 84.9721 45.7721 84.8311 45.5535C84.052 44.5491 81.3339 44.7694 81.3339 44.7694Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3309 48.3582C81.3309 48.3582 77.8337 48.3582 77.9645 49.0244C78.0954 49.6905 77.7028 51.1459 79.154 51.3714C80.8758 51.5557 82.6198 51.5177 84.3285 51.2586C84.6193 51.2121 84.8883 51.0939 85.1027 50.9183C85.3171 50.7427 85.4678 50.5172 85.5364 50.2693C85.605 50.0214 85.5887 49.7616 85.4893 49.5215C85.39 49.2815 85.212 49.0714 84.9768 48.9168C83.9181 48.1327 81.3309 48.3582 81.3309 48.3582Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7304 49.2016C75.7304 49.2016 75.2844 46.3934 74.2316 46.4703C73.4465 46.5267 71.573 47.0391 71.7455 48.2741C72.0415 49.7484 72.5949 51.1755 73.3871 52.5069C73.524 52.733 73.7341 52.92 73.992 53.0452C74.2499 53.1703 74.5445 53.2283 74.8398 53.212C75.1352 53.1958 75.4188 53.1059 75.6561 52.9535C75.8933 52.801 76.0741 52.5925 76.1765 52.3532C76.7415 51.2719 75.7304 49.2016 75.7304 49.2016Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5485 51.3631C81.5485 51.3631 78.3843 51.3631 78.5033 52.0088C78.6222 52.6545 78.2654 54.0586 79.556 54.2635C81.1151 54.4393 82.6967 54.403 84.2427 54.1559C84.5137 54.0992 84.7609 53.9785 84.9566 53.8074C85.1523 53.6363 85.2887 53.4215 85.3505 53.1873C85.4123 52.953 85.397 52.7085 85.3064 52.4813C85.2158 52.2541 85.0534 52.0532 84.8375 51.9012C83.8918 51.153 81.5485 51.3631 81.5485 51.3631Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7047 53.8139C81.7047 53.8139 79.058 53.8139 79.1591 54.3264C79.2602 54.8388 78.9628 56.0328 80.0393 56.2122C81.3428 56.3636 82.6661 56.3342 83.9588 56.125C84.1844 56.0761 84.3897 55.9742 84.5519 55.8305C84.7141 55.6869 84.8267 55.5073 84.8773 55.3117C84.9279 55.1161 84.9144 54.9122 84.8383 54.7229C84.7623 54.5335 84.6266 54.3661 84.4465 54.2393C83.6674 53.6346 81.7047 53.8139 81.7047 53.8139Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3943 25.543C71.7166 25.5482 70.0751 25.9639 68.661 26.7418C67.2468 27.5196 66.1182 28.6275 65.4065 29.9365C64.6949 31.2456 64.4294 32.7018 64.6411 34.1358C64.8527 35.5698 65.5328 36.9225 66.6021 38.0364C68.2258 39.7223 70.8844 40.9317 73.4181 40.7933C81.1857 40.3834 101.55 49.7816 101.55 49.7816V16.5547C101.55 16.5547 81.4712 25.6813 73.3943 25.543Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8122 33.4332C71.8122 31.7177 72.3491 30.034 73.3665 28.5595C74.384 27.0849 75.8442 25.8742 77.5933 25.0547C76.2208 25.3583 74.8112 25.5201 73.3943 25.5364C71.7166 25.5416 70.0751 25.9574 68.661 26.7352C67.2468 27.513 66.1182 28.6209 65.4065 29.93C64.6949 31.239 64.4294 32.6953 64.6411 34.1292C64.8527 35.5632 65.5328 36.9159 66.6021 38.0298C68.2258 39.7157 70.8844 40.9251 73.4181 40.7867C74.3182 40.7564 75.2195 40.8097 76.1064 40.9456C74.7728 40.0587 73.6924 38.9206 72.9481 37.6185C72.2037 36.3163 71.8152 34.8847 71.8122 33.4332Z",
    fill: "#90205D",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.242 37.091C122.76 28.1759 116.414 19.1897 106.067 17.0197C95.7194 14.8498 85.2897 20.3178 82.7712 29.2328C80.2526 38.1479 86.599 47.1341 96.9461 49.3041C107.293 51.474 117.723 46.006 120.242 37.091Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.957 33.1432C117.958 35.9448 116.995 38.6838 115.189 41.0137C113.383 43.3436 110.816 45.1598 107.813 46.2327C104.809 47.3055 101.503 47.5867 98.3139 47.0408C95.1246 46.4948 92.1948 45.1463 89.8952 43.1656C87.5955 41.1849 86.0292 38.6612 85.3944 35.9135C84.7597 33.1658 85.0848 30.3176 86.3289 27.7292C87.573 25.1408 89.6801 22.9284 92.3836 21.3718C95.0871 19.8152 98.2657 18.9844 101.517 18.9844C105.876 18.9857 110.055 20.4777 113.138 23.1326C116.22 25.7874 117.953 29.388 117.957 33.1432Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.521 29.7028V36.6362L88.8762 42.2167C86.9501 40.2124 85.701 37.7902 85.2657 35.2152C84.8303 32.6402 85.2255 30.0116 86.408 27.6172L101.521 29.7028Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.521 33.1543C105.521 33.8387 105.286 34.5076 104.844 35.0766C104.403 35.6455 103.776 36.0889 103.042 36.3505C102.308 36.6122 101.5 36.6804 100.721 36.5465C99.9425 36.4126 99.2272 36.0826 98.666 35.5984C98.1047 35.1141 97.7228 34.4973 97.5686 33.826C97.4144 33.1547 97.4947 32.459 97.7995 31.8271C98.1043 31.1951 98.6198 30.6552 99.2808 30.2758C99.9418 29.8963 100.719 29.6943 101.513 29.6953C102.577 29.6967 103.596 30.0617 104.348 30.7102C105.099 31.3588 105.521 32.2378 105.521 33.1543Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5642 61.7626L77.9219 59.4412L86.2604 58.5547L86.0761 61.778L78.5642 61.7626Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9767 47.3307C28.9767 47.3307 14.75 45.9676 13.5129 46.5108C12.2758 47.054 -5.76929 65.4405 -5.76929 65.4405L-16.8557 46.3776L-26.1875 49.9134C-26.1875 49.9134 -14.4945 84.2472 -12.5972 84.6367C-10.6999 85.0261 7.31549 74.7004 7.31549 74.7004L6.20923 88.316C6.20923 88.316 9.52801 99.7538 24.2305 101.932C38.9331 104.11 47.6166 94.3065 49.5139 91.0371C50.9265 88.4313 52.1404 85.749 53.1479 83.0071L59.9461 65.7121C59.9461 65.7121 79.0855 79.174 83.344 80.8241C87.6025 82.4741 91.5577 83.9602 92.0335 83.1403C92.5093 82.3204 87.7691 60.5364 87.7691 60.5364L77.6581 60.9463L78.1339 64.349C78.1339 64.349 65.0134 49.4881 63.9072 48.0071C62.8009 46.5262 59.4821 46.7824 55.5329 45.8292C51.5837 44.8761 28.9767 47.3307 28.9767 47.3307Z",
    fill: "#90205D",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 74.7088L17.8974 67.8984",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1016 70.4762L19.4723 69.6562",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9297 65.7048L63.5637 54.6719",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3672 62.1642L65.3164 57.3984",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5938 72.2656L78.7526 74.9611",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1094 64.3594L78.3948 69.2122",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.354 45.8178L27.4012 46.9093C27.4012 46.9093 24.8735 48.6772 23.452 52.7614C22.5886 55.2563 21.9542 57.8059 21.5547 60.3866L27.5618 60.6633L22.8037 64.7628C22.8037 64.7628 24.2311 66.5308 27.2287 70.3434C29.5973 73.2177 32.1801 75.9565 34.9606 78.5425L26.1582 88.3045C26.1582 88.3045 36.9055 86.2548 43.5431 79.9978C50.1806 73.7409 54.112 64.3375 54.112 64.3375L48.8959 60.7965L54.4272 59.8434C54.4272 59.8434 55.5335 52.085 49.6691 47.0323C43.8048 41.9796 34.354 45.8178 34.354 45.8178Z",
    fill: "#314155",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9764 49.0852C49.9764 49.0852 48.1326 52.2316 47.7639 58.0735C47.4784 62.6342 44.7009 68.4453 42.2504 72.5551C40.3056 75.8245 38.5629 78.0178 38.438 77.6796C38.438 77.6796 37.415 76.2652 35.7794 72.1452C35.3809 71.1613 34.9527 70.0134 34.4888 68.6862C32.1097 61.8758 30.0638 50.848 31.0094 48.6701C31.4532 47.5965 31.9818 46.5504 32.5915 45.5391C40.1807 54.3941 49.9764 49.0852 49.9764 49.0852Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3371 67.7448L42.2523 72.5566C40.3074 75.826 38.5647 78.0193 38.4398 77.6811C38.4398 77.6811 37.4168 76.2667 35.7812 72.1467L38.4398 68.0113L35.7991 63.7528L38.9156 61.0625L43.1801 64.7419L40.3371 67.7448Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7188 65.7106L38.9348 61.0781L45.2869 66.2436",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6016 45.5547C32.7794 48.2981 33.4185 51.0047 34.4989 53.5898C35.6956 56.2004 37.1773 58.7073 38.9239 61.0766L46.3644 51.9551C46.3644 51.9551 38.2934 52.6367 32.6016 45.5547Z",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2109 31.1198C55.2109 31.1198 57.471 30.8174 57.471 33.477C57.471 36.1366 56.1626 39.4111 56.1626 39.4111L55.2109 31.1198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3964 21.3272C54.3964 21.3272 55.9785 33.7181 56.1331 37.3974C56.2877 41.0768 55.8179 44.341 54.3964 45.9757C52.9749 47.6104 47.2592 54.1441 44.2854 54.4157C41.3116 54.6873 37.9631 53.3293 36.7022 52.3659C35.4413 51.4025 29.4282 43.2393 29.4282 43.2393C29.4282 43.2393 24.8486 42.9677 23.7423 37.792C22.6361 32.6163 28.7978 33.8462 28.7978 33.8462C28.7978 33.8462 25.479 29.352 25.1638 24.9963C24.8486 20.6405 23.8969 19.0007 37.4932 18.7291C51.0895 18.4575 54.3964 21.3272 54.3964 21.3272Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3254 30.0391L51.12 41.3385L45.2734 39.8421",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3981 38.4844L34.8125 39.3043",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1953 39.1484C37.635 40.3048 38.4482 41.3292 39.5395 42.1016C40.6308 42.874 41.9551 43.3623 43.357 43.5093C48.4125 44.1858 50.9403 43.371 50.9403 43.371",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4702 41.3281C38.4702 41.3281 38.3156 48.1385 41.1586 48.4101C44.0015 48.6817 43.3711 43.5111 43.3711 43.5111C41.576 43.0918 39.9052 42.3476 38.4702 41.3281Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0391 46.0469C39.4257 47.287 40.0739 48.317 41.1445 48.4195C41.4139 48.4522 41.6886 48.4219 41.9397 48.3318C42.1909 48.2416 42.4092 48.0949 42.5719 47.907C42.0188 47.0718 40.1096 46.38 39.0391 46.0469Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4008 33.16C40.4008 33.9133 40.0142 34.5231 39.5324 34.5231C39.0507 34.5231 38.6641 33.9133 38.6641 33.16C38.6641 32.4067 39.0507 31.7969 39.5324 31.7969C40.0142 31.7969 40.4008 32.4067 40.4008 33.16Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0083 31.9256C51.0083 32.6789 50.6157 33.2887 50.134 33.2887C49.6522 33.2887 49.2656 32.6789 49.2656 31.9256C49.2656 31.1723 49.6582 30.5625 50.134 30.5625C50.6098 30.5625 51.0083 31.1723 51.0083 31.9256Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7344 30.8252C37.4727 30.1021 38.4087 29.5491 39.4576 29.2162C40.5065 28.8834 41.6352 28.7812 42.7415 28.9189",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7812 28.3971C47.7812 28.3971 49.8332 25.1277 53.1341 26.7624",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.68 21.5938C37.68 21.5938 32.7851 20.9122 33.8914 22.1421C34.9977 23.372 37.5254 24.8632 36.2705 25.8163C35.0155 26.7695 31.8454 28.3786 32.006 29.219C32.1666 30.0594 32.4759 33.4415 32.006 34.2614C31.5361 35.0813 30.4239 35.2146 29.3177 35.0762C28.2114 34.9379 26.6293 32.4884 25.9989 31.8068C25.3684 31.1253 19.6766 26.2263 20.7828 22.2754C21.8891 18.3244 33.7427 15.1934 33.7427 15.1934C33.7427 15.1934 41.314 7.84492 46.3874 7.70656C51.4607 7.5682 49.5456 11.6575 49.3612 12.0623C49.1768 12.4672 56.6292 11.6575 58.0507 15.6033C59.4721 19.5491 59.0023 20.6407 52.5194 22.1421C46.0365 23.6436 37.68 21.5938 37.68 21.5938Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.25689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.358 16.1562L124.475 19.0259L127.14 20.1738L119.812 22.0904L134.688 20.3685L130.917 18.8363L137.358 16.1562Z",
    fill: "#90205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.001 43.1729L126.97 40.8516L128.778 42.8911L121.219 41.8252L135.451 45.935L132.846 43.1268L140.001 43.1729Z",
    fill: "#90205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.002 61.687L115.029 55.1994L115.778 57.6848L109.289 54.1797L120.566 62.7221L119.43 59.2631L126.002 61.687Z",
    fill: "#90205D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2080_2396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 102,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.bce00987.svg";
export { ForwardRef as ReactComponent };